const $ = require('jquery');
require('jscroll');
const nunjucks = require('nunjucks');
const redux = require('redux');
const {debounce}  = require('lodash');

$(document).ready(function() {
	// open source links in new tag
	$(".news-single .link-container a").attr('target', '_blank');


	if ($(".news-list-view").length == 0) {
		return;
	}

	nunjucks.configure('/template/dist/views-news', {autoescape: true});

	const itemsContainer = $('.news-list-view');
	const hasSeachForm = !!$('.news-search-form').length;
	let news = itemsContainer.find('.article');
	itemsContainer.empty();
	itemsContainer.addClass('visible');

	var defaultCount = 11;
	if (itemsContainer.hasClass('knowledgebase-list-view')) {
		defaultCount = 12;
	}

	const initialCount = defaultCount;
	const loadValue = 6;
	let highlightNews = [];
	let normalNews = [];
	let scrollTimer, lastScrollFireTime = 0;


	/*
	* sort items and display
	*/
	news.sort(function (a, b) {
		return $(b).data("date") - $(a).data("date")
	});

	if (!itemsContainer.hasClass('no-filters')) {
		let cleanCategories = getCleandCategories();
		if ($(".recipies-list-view").length != 0) {
			sortedCategories = cleanCategories.sort(sortMonths);
		} else {
			sortedCategories = cleanCategories;
		}
		cats = nunjucks.render('list-item-categories.html.twig', {
			categories: sortedCategories,
			allLabel: newsLabels[0]['all']
		});
		$('.news-container__list-categories').html(cats);
	}

	news.toArray()
		.map(item => {
			let categories = ('' + $(item).data('catid'))
				.split(',')
				.map(category => parseInt(category))

			if (categories.includes(5) && highlightNews.length < 2) {
				highlightNews.push(item);
			} else {
				normalNews.push(item);
			}
			return categories
		})


	/* re init the array*/
	news = highlightNews.concat(normalNews);

	/**
	 * new redux store that manages the filter state
	 */
	const store = redux.createStore(reducer)

	if (hasSeachForm) {
		store.subscribe(onChangeAjax)
	} else {
		store.subscribe(onChangeNoAjax)
	}

	store.dispatch({type: 'filter', activeFilter: 'all'})

	/**
	 *
	 * button click => update redux store
	 */
	$(document).on('click', '.news-category__item', function () {
		activeFilter = $(this).data('category');
		store.dispatch({type: 'filter', activeFilter: activeFilter})
	});

	$(window).on('scroll', debounce(function () {
		if ($('.news-list-view').length && $('.news-list-view')[0].getBoundingClientRect().bottom - window.innerHeight < 150) {
			store.dispatch({type: 'page'})
		}
	}, 50));

	$(document).on('submit', '.news-search-form form', function () {
		store.dispatch({type: 'search',
			search: $('#news-subject').val()});
		return false;
	});

	$(document).on('click', '.news a.reset-filter', function () {
		store.dispatch({type: 'reset'});
	});

	/**
	 *
	 * execute on state change of redux store
	 * set active buttons
	 * and render items
	 */
	function onChangeNoAjax() {
		const filter = store.getState().filter;
		const page = store.getState().page;
		setActiveButtons(filter);
		setFilterClass(filter);
		filteredItems = sort(filterItems(filter)).slice(0, initialCount + page * loadValue)
		$(filteredItems).removeClass('highlighted')
		if (!filter.size) {
			$(filteredItems.slice(0, 2)
				.filter(item => ('' + $(item).data('catid'))
					.split(',')
					.includes('5')
				)
			).addClass('highlighted')
		}

		itemsContainer.html(filteredItems);
	}

	/**
	 *
	 * execute on state change of redux store
	 * set active buttons
	 * and render items
	 */
	async function onChangeAjax() {
		const filter = store.getState().filter;
		const subject = store.getState().search;
		const page = store.getState().page;
		const firstEmptyPage = store.getState().firstEmptyPage;
		setActiveButtons(filter);
		setFilterClass(filter);
		setSearchSubject(subject);

		if(firstEmptyPage > -1 && page >= firstEmptyPage) {
			return;
		}

		let data = await requestNews(filter, page, subject)
		if(!page) {
			$('.recipies-list-view').html(data)
		} else {
			$('.recipies-list-view').append(data)
		}
		if(!data.trim()) {
			store.dispatch({type: 'firstEmptyPage', page: page});
		}
		if(!data.trim() && page === 0) {
			$('.hide-when-no-result').hide();
		} else {
			$('.hide-when-no-result').show();
		}
	}

	async function requestNews(filter, page, subject){
		const offset = page ? initialCount + (page -1)  * loadValue : 0;
		const limit = page ? loadValue : initialCount;
		const payload = {
			type: 6001,
			tx_psrnews_ajax: {
				overwriteDemand: {
					categories: [...filter.values()].join(','),
					offset,
					limit
				},
				search: {
					subject: subject
				}
			}
		}

		const url = window.recipeSearchUrl + '&' + $.param(payload);
		const response = await fetch(url, {
			method: 'GET', // *GET, POST, PUT, DELETE, etc.
			mode: 'no-cors', // no-cors, *cors, same-origin
			cache: 'default', // *default, no-cache, reload, force-cache, only-if-cached
			// credentials: 'same-origin', // include, *same-origin, omit
			headers: {
				// 'Content-Type': 'multipart/form-data'
				// 'Content-Type': 'application/x-www-form-urlencoded',
			},
			redirect: 'follow', // manual, *follow, error
			referrer: 'client', // no-referrer, *client
		});
		return await response.text()
	}


	function getCleandCategories() {
		let textArea = document.createElement('textarea');
		let categories = (window.newsCategoriesInUse || [])
			.filter(cat => window.filterCategories.news.includes(cat.uid))
			.map(cat => [cat.uid, decodeURIComponent(cat.title)])
		return Array.from(new Map(categories))
			.map(catArr => ({uid: '' + catArr[0], title: catArr[1]}))
	}

	/**
	 *
	 * @returns {{filter: *, search: string, firstEmptyPage: number, page: number}}
	 */
	function getEmptyState() {
		return {filter: new Set([]), search: '', page: 0, firstEmptyPage: -1}
	}

	/**
	 * manage state
	 *
	 * @param {{filter: *, search: string, firstEmptyPage: number, page: number}} state
	 * @param {{type: string, activeFilter: <String|int>}} action
	 * @returns {{filter: Set<String|int>}}
	 */
	function reducer (state = getEmptyState(), action= {}) {
		if(action.type === 'reset') {
			return getEmptyState();
		}

		return {
			filter: filterReducer(state.filter, action),
			page: pageReducer(state.page, action),
			search: searchReducer(state.search, action),
			firstEmptyPage: firstEmptyPageReducer(state.firstEmptyPage, action)
		}
	}

	/**
	 *
	 * @param {int} firstEmptyPage
	 * @param {Object} action
	 */
	function firstEmptyPageReducer(firstEmptyPage, action) {
		if(['filter', 'search'].includes(action.type)) {
			return -1
		} else if(action.type === 'firstEmptyPage') {
			return action.page
		}
		return firstEmptyPage
	}

	/**
	 *
	 * @param {string} search
	 * @param {Object} action
	 */
	function searchReducer(search, action) {
		if(action.type == 'search') {
			search = action.search ? ''+action.search : ''
		}
		return search
	}

	/**
	 *
	 * @param {Set<String|int>} filter
	 * @param {Object} action
	 * @returns {*}
	 */
	function filterReducer(filter, action) {
		if(action.type === 'filter') {
			if(action.activeFilter === 'all') {
				filter = new Set([])
			} else {
				filter.has(action.activeFilter)
					? filter.delete(action.activeFilter)
					: filter.add(action.activeFilter)
				filter = new Set([...filter])
			}
		}
		return filter
	}

	/**
	 *
	 * @param {int} page
	 * @param {Object} action
	 */
	function pageReducer(page, action) {
		if(action.type == 'page') {
			page++
		} else if(['filter', 'search'].includes(action.type)) {
			page = 0
		}
		return page
	}


	/**
	 * set active classes of buttons
	 * no filter category == all
	 *
	 * @param {Set<any>}filter
	 */
	function setActiveButtons(filter) {
		$('.filter-buttons button').removeClass('active');
		if(!filter.size) {
			$('.filter-buttons .all').addClass('active');
		} else {
			$('.filter-buttons button').filter((i, button) => {
				return filter.has($(button).data('category'))
			}).addClass('active')
		}
	}

	function setSearchSubject(subject) {
		$('#news-subject').val(subject)
	}

	/**
	 * set filter class for list
	 * no filter category == all
	 *
	 * @param {Set<any>}filter
	 */
	function setFilterClass(filter) {
		$('.news-container-list-items').removeClass('filtered');
		if(filter.size) {
			$('.news-container-list-items').addClass('filtered');
		}
	}

	/**
	 * filter items by category
	 * no filter category == all
	 *
	 * @param {Set<any>}filter
	 * @returns {Array<Object>}
	 */
	function filterItems(filter) {
		if(!filter.size) {
			return news.slice()
		}

		return news.slice()
			.filter(news => {
				return ('' + $(news).data('catid'))
					.split(',')
					.map(category => +category)
					.some(categoryUid => filter.has(categoryUid))
			})
	}

	/**
	 *
	 * @param {Array<Object>} news
	 * @returns {Array<Object>}
	 */
	function sort (news) {
		let sortednews = news.slice().sort((a,b) => a.sorting - b.sorting)
		let lightHouses = sortednews.filter(news => news.lighthouse)
		let nonLightHouses = sortednews.filter(news => !news.lighthouse)

		return lightHouses.splice(0,2)
			.concat(nonLightHouses.splice(0,6))
			.concat(lightHouses)
			.concat(nonLightHouses)
	}

  /**
   * compare categories by uid to set correct ordering of months
   *
   * @param a
   * @param b
   * @returns {number}
   */
	function sortMonths(a, b) {
    let comparison = 0;
    if (a.uid > b.uid) {
      comparison = 1;
    } else if (a.uid < b.uid) {
      comparison = -1;
    }
    return comparison;
  }
});
